import React, { useContext, useState, useEffect } from "react";
import BaseSearchModal from "../Common/BaseSearchModal";
import { CenterData } from "../../data/CenterData";
import { CenterContext } from "../../contexts/CenterContext";

const CenterSearchModal = ({ show, onClose, onSave, initialData }) => {
  const { centerData, searchCenterByTitle } = useContext(CenterContext);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    setSearchResults((prev) => ({ ...prev, ["center_title"]: CenterData.fromJsonArray(centerData) }));
  }, [centerData]);

  const handleSearch = async (query, fieldName) => {
    if (!query) {
      setSearchResults((prev) => ({ ...prev, [fieldName]: [] }));
      return;
    }

    try {
      await searchCenterByTitle(query);
      // setSearchResults((prev) => ({
      //   ...prev, [fieldName]: CenterData.fromJsonArray(centerData).map(item => ({
      //     center_title: item.title, // "title"을 "center_title"로 매핑
      //     ...item, // 기존의 item 필드 유지
      //   }))
      // }));
      setSearchResults((prev) => ({
        ...prev,
        [fieldName]: CenterData.fromJsonArray(centerData).map(item => item.title),
      }));  // center title만 추출
    } catch (error) {
      console.error("검색 오류:", error);
      setSearchResults((prev) => ({ ...prev, [fieldName]: [] }));
    }
  };

  const handleSave = (data) => {
    const selectedCenter =
      Array.isArray(searchResults.center_title) && searchResults.center_title.length > 0
        ? searchResults.center_title.find(item => item.title === data.center_title)
        : null;

    data['selectedCenter'] = selectedCenter;
    onSave(data);
  }

  const fields = [
    { name: "id", label: "id", type: "hidden", placeholder: "id" },
    { name: "specialization", label: "전문분야", type: "text", placeholder: "전문분야 입력" },
    {
      name: "center_title",
      label: "센터",
      type: "text",
      placeholder: "센터 검색",
      onSearch: handleSearch, // 검색 함수 전달
    },
  ];

  return (
    <BaseSearchModal
      title="소속 센터 정보"
      show={show}
      onClose={onClose}
      onSave={handleSave}
      fields={fields}
      searchResults={searchResults}
      initialData={initialData}
    />
  );
};

export default CenterSearchModal;
